import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { CategoryService } from '../../Services/category.service';
import { ApplyPercentage } from '../../models/Categories Requests DTO/apply-percentage.model';

@Component({
  selector: 'app-percentage-box',
  templateUrl: './percentage-box.component.html',
  styleUrl: './percentage-box.component.scss'
})
export class PercentageBoxComponent {
  type = input.required<string>();
  id = input.required<number>();
  entity = input.required<string>();
  @Output() addedPercentage = new EventEmitter<boolean>(false);
  @Output() errorMessage = new EventEmitter<string>();


  categoryService = inject(CategoryService);
  percentageValue?: number;
  model: ApplyPercentage = {
    type: '',
    percentage: 0,
    id: 0,
    entity: ''
  }

  submitIncrease() {
    this.model.id = this.id();
    this.model.percentage = this.percentageValue;
    this.model.type = this.type();
    this.model.entity = this.entity();
    
    this.categoryService.applyPercentage(this.model).subscribe({
      next: (response) => {
        // Handle successful response here
        //console.log('Percentage applied successfully!', response);
        this.addedPercentage.emit(true);
        this.clearModel();

      },
      error: (error) => {
        this.errorMessage.emit('There are no menu items under this category!');
    }
  });
  }

  submitDecrease() {

    this.model.id = this.id();
    this.model.percentage = this.percentageValue;
    this.model.type = this.type();
    this.model.entity = this.entity();
  
    this.categoryService.applyPercentage(this.model).subscribe({
      next: (response) => {
        // Handle successful response here
        //console.log('Percentage applied successfully!', response);
        this.addedPercentage.emit(true);
        this.clearModel();


      },
      error: (error) => {
        this.errorMessage.emit('There are no menu items under this category!');
    }
  });
  }

  private clearModel() {
    this.model = {
      type: '',
      percentage: 0,
      id: 0,
      entity: ''
    };
    this.percentageValue = undefined;
  }
  
  
}
